// TODO: подумать как вынести в общий компонент
import { FC, useEffect, useState } from 'react'

import Button from 'components/parts/button/button'
import usePCWindow from 'hooks/usePCWindow'

import ButtonThemes from 'components/parts/button/themes'
import { ITargetAudience } from './data'
import { ScreenSize } from 'constants/media-constanst'

import styles from './course-specialties.module.scss'

const CourseSpecialties: FC<ITargetAudience> = ({
  title = 'Перечень аккредитованных специальностей',
  shortSpecCount,
  specialties,
}) => {
  const isMobile = usePCWindow(ScreenSize.mobile)
  const [specs, setSpecs] = useState(specialties)

  useEffect(() => {
    if (isMobile && shortSpecCount && specialties.length > shortSpecCount) {
      const specList = specialties.slice(0, shortSpecCount)
      setSpecs(specList)
    } else {
      setSpecs(specialties)
    }
  }, [isMobile, shortSpecCount])

  const showAllSpecs = () => setSpecs(specialties)
  const hiddenSpecsCount = shortSpecCount && specialties.length - shortSpecCount

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.wrapper}>
        {specs.map((specialty, index) => {
          return (
            <span key={index} className={styles.speciality}>
              {specialty}
            </span>
          )
        })}
        {shortSpecCount && specs.length === shortSpecCount && (
          <div className={styles.btnWrap}>
            <Button theme={ButtonThemes.GREY} onClick={showAllSpecs}>
              {`Еще ${hiddenSpecsCount} специальности`}
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default CourseSpecialties
